module.exports = __webpack_public_path__ + "img/portrait-rank-3@3x.ed1566ed.png";